<template>
  <div class="bg-wrapper">
    <div class="bg-wrapper__body">
      <div class="upload-wrapper">
        <div class="upload-wrapper__header">
          <span>{{
            uploadWrapper ? "Upload Background" : "Select Background"
          }}</span>
          <el-button
            @click="switchUpload"
            size="small"
            :icon="uploadWrapper ? 'el-icon-files' : 'el-icon-plus'"
          ></el-button>
        </div>
        <div class="upload-wrapper__body">
          <ul v-if="!uploadWrapper" class="upload-list-card">
            <li
              class="display"
              v-for="item in bgList"
              :key="item.background_id"
              @click="handlePreview(item)"
              :class="selected == item ? 'active' : ''"
              :style="{
                'background-image': 'url(' + url + item.source[0] + ')',
              }"
            >
              <div v-if="item.status" class="status">Active</div>
              <el-popconfirm
                v-if="!item.status"
                confirm-button-text="OK"
                cancel-button-text="No, Thanks"
                icon="el-icon-info"
                icon-color="red"
                @confirm="handleDelete(item)"
                title="Are you sure to delete this background?"
              >
                <el-button
                  slot="reference"
                  class="action"
                  icon="el-icon-delete"
                  circle
                  type="danger"
                ></el-button>
              </el-popconfirm>
            </li>
          </ul>
          <div v-else class="form-wrapper">
            <el-form
              label-position="top"
              :rules="rules"
              ref="ruleForm"
              size="small"
              :model="form"
            >
              <el-row :gutter="12">
                <el-col :span="10">
                  <el-form-item label="Title" prop="title">
                    <el-input v-model="form.title"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="14">
                  <el-form-item label="Sub-title" prop="subtitle">
                    <el-input v-model="form.subtitle"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="Description" prop="description">
                <el-input type="textarea" v-model="form.description"></el-input>
              </el-form-item>
              <el-row :gutter="12">
                <el-col :span="12">
                  <el-form-item label="Desktop">
                    <div
                      class="upload-canvas"
                      @click="$refs.desktopFile.click()"
                    >
                      <input
                        type="file"
                        ref="desktopFile"
                        @change="onDesktopSelected"
                      />
                      <el-image
                        v-if="form.preview.desktop"
                        fit="cover"
                        class="image-wrapper"
                        :src="form.preview.desktop"
                      >
                        <div slot="error" class="image-slot">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                      <i v-else class="el-icon-plus"></i>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Mobile">
                    <div
                      class="upload-canvas__mobile"
                      @click="$refs.mobileFile.click()"
                    >
                      <input
                        type="file"
                        ref="mobileFile"
                        @change="onMobileSelected"
                      />
                      <el-image
                        v-if="form.preview.mobile"
                        fit="cover"
                        class="image-wrapper"
                        :src="form.preview.mobile"
                      >
                        <div slot="error" class="image-slot">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                      <i v-else class="el-icon-plus"></i>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div v-if="uploadWrapper" class="upload-wrapper__footer">
          <el-button @click="switchUpload" size="small">
            Cancel
          </el-button>
          <el-button
            @click="handleUpload()"
            icon="el-icon-upload"
            :loading="loading.submit"
            size="small"
            type="primary"
            v-loading.fullscreen.lock="loading.submit"
          >
            Upload
          </el-button>
        </div>
      </div>
      <div class="preview-wrapper" :class="uploadWrapper ? 'backdrop' : ''">
        <div class="preview-wrapper__header">
          <span>Preview Background</span>
        </div>
        <div class="preview-wrapper__body">
          <div class="preview">
            <div class="preview__body">
              <div
                class="desktop-preview"
                :style="{
                  'background-image': 'url(' + url + preview[0] + ')',
                }"
              >
                <div class="box"></div>
              </div>
              <div class="mobile-preview">
                <div
                  class="bg"
                  :style="{
                    'background-image': 'url(' + url + preview[1] + ')',
                  }"
                ></div>
                <div class="box"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-wrapper__footer">
      <el-button
        :disabled="selected == null"
        @click="setBackground()"
        type="primary"
        size="small"
        >Apply</el-button
      >
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { mapGetters } from "vuex";
import { timeline, gsap } from "gsap";
export default {
  name: "backgroundComponent",
  props: {
    background: {},
    bgList: Array,
  },
  data() {
    return {
      url: process.env.VUE_APP_BACKEND,
      preview: {},
      selected: null,
      uploadWrapper: false,
      form: {
        title: "",
        subtitle: "",
        description: "",
        file: {
          desktop: [],
          mobile: [],
        },
        preview: {
          desktop: "",
          mobile: "",
        },
      },
      rules: {
        title: [
          {
            required: true,
            message: "Please input image title",
            trigger: "blur",
          },
        ],
        subtitle: [
          {
            required: true,
            message: "Please input image subtitle",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "Please input image description",
            trigger: "blur",
          },
        ],
      },
      loading: {
        submit: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      activeUser: "getActiveUser",
    }),
    bgActive() {
      return process.env.VUE_APP_BACKEND + this.background.desktop;
    },
  },
  methods: {
    fileReader(file, type) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        if (type == "desktop") {
          this.form.preview.desktop = e.target.result;
        } else if (type == "mobile") {
          this.form.preview.mobile = e.target.result;
        }
      };
    },
    onDesktopSelected(file) {
      this.form.file.desktop = file.target.files[0];
      const image = this.fileReader(file.target.files[0], "desktop");
    },
    onMobileSelected(file) {
      this.form.file.mobile = file.target.files[0];
      const image = this.fileReader(file.target.files[0], "mobile");
    },
    handlePreview(item) {
      this.preview = item.source;
      this.selected = item;
    },
    switchUpload() {
      this.preview = {};
      this.selected = null;
      if (this.uploadWrapper) {
        this.$refs["ruleForm"].resetFields();
        this.form.file = {
          desktop: [],
          mobile: [],
        };
        this.form.preview = {
          desktop: "",
          mobile: "",
        };
      }
      this.uploadWrapper = !this.uploadWrapper;
    },
    handleUpload() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.loading.submit = true;
          if (
            this.form.file.desktop.length !== 0 &&
            this.form.file.mobile.length !== 0
          ) {
            let data = {
              title: this.form.title,
              subtitle: this.form.subtitle,
              description: this.form.description,
              desktop: this.form.file.desktop,
              mobile: this.form.file.mobile,
              token: this.activeUser.token,
            };

            this.$store.dispatch("submitBg", data).then((res) => {
              this.$router.push("/login");
            });
          } else {
            alert("select image first");
            this.loading.submit = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleDelete(item) {
      this.$store
        .dispatch("removeBg", {
          id: item.background_id,
          token: this.activeUser.token,
        })
        .then((res) => {
          this.$notify.success({
            title: `Background Removed`,
            message: ``,
          });
          this.$store.dispatch("getbgList", this.activeUser);
        });
    },
    setBackground() {
      this.$store
        .dispatch("changeBg", {
          id: this.selected.background_id,
          token: this.activeUser.token,
        })
        .then((res) => {
          this.$notify.success({
            title: `Background Changed`,
            message: `New Background Applied`,
          });
          this.$store.dispatch("getbgList", this.activeUser);
          this.$router.push("/login");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-wrapper {
  display: flex;
  flex-direction: column;
  height: 600px;
  padding-top: $space;

  @media screen and #{$mq-xlarge} {
    height: 750px;
  }
  &__header {
    display: flex;
    align-items: center;
    margin: 0 $space * 2;
    border-bottom: 1px solid darken(white, 15);
    .title-wrapper {
      border: 1px solid darken(white, 15);
      border-bottom: 0;
      padding: $space / 2;
      border-top-left-radius: $space / 2;
      border-top-right-radius: $space / 2;
      background-color: darken(white, 10);
      font-weight: 600;
    }
  }
  &__body {
    display: flex;
    flex: 1;
    gap: $space;
    padding: $space $space * 2;
    justify-content: space-between;
    overflow: auto;
  }
  &__footer {
    height: 50px;
    padding: 0 $space * 2;
    margin-top: $space;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    box-shadow: -2px 0 20px rgba(0, 0, 0, 0.05);
  }
}
.upload-wrapper {
  flex: 40%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  border: 1px solid darken(white, 15);

  &__header {
    height: 50px;
    padding: 0 $space;
    display: flex;
    align-items: center;
    border-bottom: 1px solid darken(white, 15);
    font-weight: 600;
    font-size: 1rem;
    justify-content: space-between;
    background-color: white;
  }
  &__body {
    padding: $space;
    flex: 1;
    position: relative;
    border-radius: $space / 2;
    overflow: auto;
  }
  &__footer {
    height: 50px;
    border-top: 1px dashed;
    padding: 0 $space;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.preview-wrapper {
  flex: 60%;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 15);

  &__header {
    height: 50px;
    padding: 0 $space;
    display: flex;
    align-items: center;
    border-bottom: 1px solid darken(white, 15);
    background-color: white;
    font-weight: 600;
    font-size: 1rem;
    justify-content: space-between;
  }
  &__body {
    flex: 1;
    position: relative;
    overflow: hidden;
    border-radius: $space / 2;
  }

  &.backdrop {
    position: relative;
    overflow: hidden;

    &:before {
      content: "Preview Disabled!";
      position: absolute;
      background-color: transparentize($color: #000000, $amount: 0.2);
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
      display: flex;
      color: white;
      align-items: center;
      justify-content: center;
      font-size: 1.2rem;
      font-weight: 400;
    }
  }
}

.form-wrapper {
  .upload-canvas {
    &__mobile {
      width: 130px;
    }

    &,
    &__mobile {
      height: 110px;
      border: 1px dashed;
      border-radius: $space / 2;
      position: relative;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: white;
      transition: 0.2s all ease-in-out;

      > input {
        display: none;
      }

      &:hover {
        border-color: $notif-color;
        cursor: pointer;
      }

      i {
        font-size: 1.5rem;
        color: $primary-color;
      }
    }
  }
}

.upload-list-card {
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, 130px) 130px;
  grid-gap: $space / 2;
  grid-template-rows: repeat(3);
  li {
    position: relative;
    border: 1px solid darken(white, 5);
    box-shadow: 2px 4px 16px rgba(0, 0, 0, 0.03);
    height: 120px;
    width: 120px;
    list-style: none;
    border-radius: $space / 2;
    transition: 0.2s all ease-in-out;
    &:hover {
      border: 1px solid darken(white, 8);
      box-shadow: 2px 4px 16px rgba(0, 0, 0, 0.08);
      cursor: pointer;
      .action {
        opacity: 1;
      }
    }
    .action {
      position: absolute;
      bottom: $space;
      right: $space;
      opacity: 0;
      transition: all 0.2s ease-in-out;
    }
    &.display {
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: space-around;
      background-size: cover;
      background-position: center center;

      &:hover {
        border: 1px solid darken(white, 10);
        transform: scale(1.05);
      }
    }
    .status {
      background-color: $primary-color;
      color: white;
      position: absolute;
      top: $space;
      left: 0;
      width: 45px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 $space;
      box-shadow: 2px 4px 16px rgba(0, 0, 0, 0.08);
      border-top-right-radius: $space;
      border-bottom-right-radius: $space;
      text-transform: uppercase;
      letter-spacing: 1px;
      font-size: 0.75rem;
      font-weight: 600;
    }
    &.active {
      transition: all ease-in-out 0.5s;
      &:before {
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        right: 0;
        height: 5px;
        background: $notif-color;
      }
    }
  }
}

.preview {
  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: column;
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    padding: 0 $space;
    background: whitesmoke;
  }
  &__body {
    display: flex;
    flex: 1;
    background-color: darken(white, 0.2);
    align-items: flex-start;
    justify-content: center;
    padding: $space * 2;
    gap: $space;
  }
}

.mobile-preview {
  border-radius: $space;
  overflow: hidden;
  width: 200px;
  height: 355px;
  background-color: darken(white, 15);
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.05), -4px -4px 12px #00000005;
  border: 1px dashed;
  position: relative;

  .bg {
    height: 70%;
    border-bottom: 4px solid $primary-color;
    border-bottom-left-radius: $space;
    border-bottom-right-radius: $space;
    background-color: white;
    background-size: cover;
    background-position: center center;
  }
  .box {
    height: 130px;
    width: 90%;
    border: 1px dashed black;
    border-radius: $space / 2;
    background-color: white;
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
  }
}

.desktop-preview {
  width: 500px;
  height: 281px;
  border-radius: $space;
  background-color: white;
  background-size: cover;
  background-position: center center;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.05),
    -4px -4px 12px rgba(0, 0, 0, 0.02);
  border: 1px dashed;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  .box {
    height: 120px;
    width: 150px;
    border: 1px dashed darken(white, 10);
    background-color: transparentize($color: white, $amount: 0.3);
  }
}
</style>
